import React, {Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import CualEsMayor from '../../../Compartidos/CualEsMayor';

import { setearEjercicioAction, setearUrlAnteriorAction } from '../../../../../actions/estadoEjercicioActions';

const instrucciones = 'Indica que grupo tiene más dibujos.';
const miniInstrucciones = 'Indica que grupo tiene más dibujos.';

const M15 = () => {
    
    const dispatch = useDispatch();

    const [data, setData] = useState();
    const [indexes, setIndexes] = useState();

    const informacion = useSelector(state => state.informacion.info_DB);

    useEffect(() => {
        dispatch(setearEjercicioAction('M15') );
        dispatch(setearUrlAnteriorAction('matematica/estimacion-y-nocion-de-cantidad/estimacion-de-cantidad/'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(informacion.length === 0){
            return;
        }
        const newList = JSON.parse(JSON.stringify(informacion));
        setData(newList);
        setIndexes(Object.keys(newList).length);
    }, [informacion])

    return (
        <Fragment>
            <CualEsMayor bg='#FCFBFB' bs='0px 4px 4px rgba(0, 0, 0, 0.25)' m='1vh 0px 0px 0px' w='32vw' wm='27vw' wt='18vw' wd='15vw' wlg='13vw' data={data} indexes={indexes} ejercicio="M15" instrucciones={instrucciones} miniInstrucciones={miniInstrucciones}  minMay={false} estrellas={true} carrito={true} />
        </Fragment>
    );
}
 
export default M15;